import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {IConfirmationDialogInput} from '../../types/confirmation.type';


@Component({
    selector: 'npa-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.styl']
})
export class ConfirmationDialogComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: IConfirmationDialogInput) {
    }

    ngOnInit() {
    }

    confirm() {
        this.dialogRef.close({
            isConfirmed: true,
        });
    }

    cancel() {
        this.dialogRef.close({
            isConfirmed: false,
        });
    }
}
